import { Tag } from '../../shared/models/tag.model';


/**
 * Tag that associates additional information with a business.
 */
export class BusinessTag extends Tag {
  /**
   * Unique identifier for this record in the database. This property identifies the record that links this tag to a
   * specific business (as oppsoed to Tag.tagId, which identifies the tag definition record).
   */
  businessTagId: number;

  /**
   * Business record ID for which this record applies
   */
  businessId: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Date tag was updated
   */
  updateDate: Date;

  /**
   * The active status of the tag
   */

  /**
   * Parses tag
   * @param data {any} Tag as returned by API
   * @return {Tag} Parsed tag
   */
  static parse(data: any): Tag {
    const tag = Tag.parse(data);
    return Object.assign(tag, {
      businessTagId: data.businessTagId,
      businessId: data.businessId,
      isActive: data.isActive,
      sourceId: data.sourceId,
      updateDate: Date.parse(data.updateDate)
    });
  }
}
